import React, { Component, ReactNode, FC } from "react";

import { Menu as MenuType } from "types/Menu";

function containsWord(m: MenuType, term?: string) {
  // si term n'est pas présent, tout match
  if (!term) {
    return true;
  }

  // si term est présent dans le label, ça match
  if (m.label.toLowerCase().indexOf(term) !== -1) {
    return true;
    // on vérifie également les enfants
  } else if (m.children !== null) {
    const contains: boolean[] = [];

    for (let child of m.children) {
      contains.push(containsWord(child, term));
    }

    return contains.reduce((acc, curr) => (curr === true ? curr : acc), false);
  }

  // si on arrive ici, rien ne match
  return false;
}

interface MenuProps {
  menu: Array<MenuType>;
  open: Record<string, boolean>;
  isFilter?: boolean;
  classNames?: {
    ulClassName?: string;
    liClassName?: string;
  };
  styles?: {
    ulStyle?: React.CSSProperties;
    liStyle?: React.CSSProperties;
  };
  render(item: MenuType, onClickMenu?: () => void): JSX.Element | JSX.Element[];
  onClickMenu(key: string): void;
}

export const Menu: FC<MenuProps> = ({
  classNames = {},
  styles = {},
  menu = [],
  isFilter = false,
  open,
  render,
  onClickMenu
}) => {
  return (
    <>
      {menu.map(item => {
        const key = item.id || item.code || item.label;

        if (item.children.length === 0) {
          return (
            <li
              className={classNames.liClassName}
              style={styles.liStyle}
              key={key}
            >
              {render(item)}
            </li>
          );
        } else {
          const isOpen = isFilter || open[item.code || item.label];
          const children = isOpen ? (
            <ul
              className={classNames.ulClassName}
              style={{
                ...styles.ulStyle,
                display: isOpen ? "block" : "none"
              }}
            >
              <Menu
                menu={item.children}
                isFilter={isFilter}
                open={open}
                render={render}
                onClickMenu={onClickMenu}
                classNames={classNames}
                styles={styles}
              />
            </ul>
          ) : null;

          return (
            <li
              key={key}
              className={classNames.liClassName}
              style={styles.liStyle}
            >
              {render(item, () => onClickMenu(item.code || item.label))}
              {children}
            </li>
          );
        }
      })}
    </>
  );
};

interface CollapseComponentProps {
  defaultOpen?: Record<string, boolean>;
  render(props: CollapseComponentRenderProps): JSX.Element | JSX.Element[];
}

interface CollapseComponentRenderProps {
  open: Record<string, boolean>;
  onClickMenu(key: string): void;
}

interface CollapseComponentState {
  open: Record<string, boolean>;
}

export class CollapseComponent extends Component<CollapseComponentProps, CollapseComponentState> {
  state: CollapseComponentState = {
    open: this.props.defaultOpen || {}
  };

  onClickMenuItem = (key: string) => {
    const current = this.state.open[key];
    this.setState({
      open: {
        ...this.state.open,
        [key]: current !== undefined ? !current : true
      }
    });
  };

  render() {
    return this.props.render({ open: this.state.open, onClickMenu: this.onClickMenuItem });
  }
}
